import { AxiosError } from 'axios';
import { showErrorAxios } from "infra/helpers/alerta";
import http from "infra/http";
import { useMutation, useQueryClient } from "react-query";
import { RateioForm } from "../typings";

function useCreateRateio(onSuccess: (id: string) => any) {
  const queryClient = useQueryClient();

  return useMutation<{data: {data: string}}, AxiosError<any>, {data: RateioForm}, any>(
    "create/v1/rateio",
    ({ data }: { data: RateioForm }) =>
      http.post('/v1/rateio', data),
    {
      retry: false,
      onSuccess: ({data}) => {
        queryClient.invalidateQueries("/v1/rateio");
        onSuccess(data.data)
      },
      onError: (e) => {
        showErrorAxios(e)
      }
    }
  );
}

export default useCreateRateio;
